import { createRoot } from 'react-dom/client';
import MInnerToast, { IInnerToast } from './mInnerToast';
const animationTime = 300; // 动画时间，单位（ms）
const appearAnimation = [ { opacity: 0 }, { opacity: 1 } ]; // 淡入动画效果
const disappearAnimation  = [ { opacity: 1 }, { opacity: 0 } ]; // 淡出动画效果
const TOAST_ID = 'toast-element';

const renderToast = (comp: JSX.Element, isAnimate?: boolean) => {
  const toastElem = document.createElement('div');
  toastElem.id = TOAST_ID;

  const prevToastElem= document.getElementById(TOAST_ID);
  if (prevToastElem && document.body.contains(prevToastElem)) {
    document.body.replaceChild(toastElem, prevToastElem);
  } else {
    document.body.appendChild(toastElem);
    if (isAnimate) {
      toastElem.animate(appearAnimation, animationTime);
    }
  }

  // 通过 createRoot 将 React 组件渲染到浏览器 DOM 节点里面
  const root = createRoot(toastElem);
  root.render(comp);

  return () => {
    const func = () => {
      root.unmount();
      if (document.body.contains(toastElem)) {
        document.body.removeChild(toastElem);
      }
    };

    if (!isAnimate) {
      func();
    } else {
      toastElem.animate(disappearAnimation, animationTime).onfinish = func;
    }

  };
};

const removeToast = () => {
  const toastElem = document.getElementById(TOAST_ID);
  if (toastElem && document.body.contains(toastElem)) {
    document.body.removeChild(toastElem);
    // toastElem.animate(disappearAnimation, animationTime).onfinish = function () {
    //   document.body.removeChild(toastElem);
    // };
  }
};

const show = (options: IInnerToast) => {
  const close = renderToast(
  <MInnerToast {...options} onClose={() => { close(); options.onClose?.() }} />, options.animate,
  );
};

const clear = () => {
  removeToast();
};

const Toast: { show: typeof show; clear: typeof clear; } = { show, clear };

export default Toast;
